export default function typeMapFactory ($filter) {
  'ngInject';
  const tranlsteFilter = $filter('translate');
  return {
    normal: tranlsteFilter('home-infringements-text066'),
    site: tranlsteFilter('home-infringements-text067'),
    article: tranlsteFilter('home-infringements-text068'),
    in_one_article: '单篇文章',
    in_one_site: '单个网站'
  }
}


// WEBPACK FOOTER //
// ./src/app/services/typemap.js